import React from 'react'
import Carousel from 'react-multi-carousel'
import PropTypes from 'prop-types'
import 'react-multi-carousel/lib/styles.css'

const TCSalonCycleCarousel = props => {
  const responsive = {
    desktop: {
      breakpoint: { max: 99999, min: 1400 },
      items: 5,
    },
    mobile: {
      breakpoint: { max: 991, min: 0 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1400, min: 991 },
      items: 3,
    },
  }

  return (
    <Carousel
      className="saloncycle-carousel"
      draggable={false}
      infinite={true}
      removeArrowOnDeviceType="desktop"
      responsive={responsive}
    >
      {props.products.map((item) =>
        <div className="item"
          key={btoa(item.link)}
          onClick={() => window.location.href=item.link}
        >
          <div className="saloncycle-carousel__img">
            <img
              alt=""
              src={item.image}
            />
          </div>
          <div className="mt-3">
            <div className="saloncycle-carousel__title">
              <span>{item.name}</span>
            </div>
            <div className="saloncycle-carousel__price">
              <span>{item.price}</span>
            </div>
          </div>
        </div>,
      )}
    </Carousel>
  )
}

TCSalonCycleCarousel.propTypes = {
  products: PropTypes.array,
}

export default TCSalonCycleCarousel
